<template>
  <div class="parallel-list">
    <el-card class="box-card" shadow="never">
      <el-button type="primary" @click="showAddDiloag(true)">新增并网点</el-button>
      <el-table :data="tableData" border height="64vh" style="width: 100%;margin-top:10px;"
        :row-class-name="tableRowClassName">
        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
        <el-table-column prop="projectName" label="项目名称"></el-table-column>
        <el-table-column prop="owner" label="使用方名称"></el-table-column>
        <el-table-column prop="locationStr" label="使用地址"></el-table-column>
        <el-table-column prop="gridName" label="并网点名称" width="140"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operatorName" label="操作人" width="120"></el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showAddDiloag(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="copy(scope.row)">复制</el-button>
            <el-button type="text" size="small" @click="bindDevice(scope.row)">设备绑定</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.pageNum"
        :page-sizes="pageList" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"
        style="text-align: center;margin-top:20px;"></el-pagination>
    </el-card>
    <!-- 复制 -->
    <Dialog ref="dlgCopy" :title="dlgCopyTitle" class="parallel-dlg">
      <el-form ref="copyFormData" :rules="copyRules" :model="formData" label-width="100px">
        <el-form-item label="并网点名称" prop="gridName">
          <el-input v-model="formData.gridName" placeholder="请输入并网点名称" maxlength="120"></el-input>
        </el-form-item>
        <el-form-item label="电压等级" prop="volLevel">
          <el-select v-model="formData.volLevel" placeholder="请选择并网点电压等级">
            <el-option v-for="(item,index) in volLevelOptions" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="btn-tools">
          <el-button class="btn" type="primary" @click="onCopy('copyFormData')">保存</el-button>
          <el-button class="btn" type="primary" @click="onCopyCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </Dialog>
    <!-- 添加、编辑，详情 -->
    <Dialog ref="dlgAdd" :title="dlgTitle" class="parallel-dlg">
      <el-form ref="formData" :rules="rules" :model="formData" label-width="100px">
        <el-form-item label="项目名称" prop="projectId">
          <span v-if="dlgTitle!=='详情'">
            <el-select v-model="formData.projectId" :disabled="!!formData.id" placeholder="请选择项目名称"
              @change="getProjectDetails">
              <el-option v-for="(item,index) in projectOptions" :key="index" :label="item.projectName"
                :value="item.projectId"></el-option>
            </el-select>
          </span>
          <span v-else>
            {{formData.projectName}}
          </span>
        </el-form-item>
        <el-form-item label="使用方名称">
          <span v-if="dlgTitle!=='详情'">
            <el-input v-model="formData.owner" disabled placeholder="切换项目带入使用方名称"></el-input>
          </span>
          <span v-else>
            {{formData.owner}}
          </span>
        </el-form-item>
        <el-form-item label="使用方地址">
          <span v-if="dlgTitle!=='详情'">
            <el-input v-model="formData.locationStr" disabled placeholder="切换项目带入使用方地址"></el-input>
          </span>
          <span v-else>
            {{formData.locationStr}}
          </span>
        </el-form-item>
        <el-form-item label="用电类型" prop="electricityType">
          <el-select v-model="formData.electricityType" placeholder="请选择用电类型" disabled>
            <el-option v-for="(item,index) in electricityTypeOptions" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="并网点名称" prop="gridName">
          <span v-if="dlgTitle!=='详情'">
            <el-input v-model="formData.gridName" placeholder="请输入并网点名称" maxlength="120"></el-input>
          </span>
          <span v-else>
            {{formData.gridName}}
          </span>
        </el-form-item>
        <el-form-item label="电压等级" prop="volLevel">
          <el-select v-model="formData.volLevel" placeholder="请选择并网点电压等级">
            <el-option v-for="(item,index) in volLevelOptions" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="btn-tools">
          <span v-if="dlgTitle!=='详情'">
            <el-button class="btn" type="primary" @click="onSave('formData')">保存</el-button>
            <el-button class="btn" type="primary" @click="onCancel">取消</el-button>
          </span>
          <span v-else>
            <el-button class="btn" type="primary" @click="onCancel">关闭</el-button>
          </span>
        </el-form-item>
      </el-form>
    </Dialog>
  </div>
</template>

<script>
  import API from '@/api/parallel';
  import Dialog from '@/components/dialog';

  export default {
    components: {
      Dialog
    },
    props: ['params'],
    data() {
      return {
        currentProject: {},
        projectId: '',
        form: {
          pageSize: 10,
          pageNum: 1
        },
        electricityTypeOptions: [{
            label: "大工业（≥315KVA)",
            value: 1
          },
          {
            label: "一般工商业 （普通工业）",
            value: 2
          },
          {
            label: "一般工商业（普通工业除外）",
            value: 3
          },
          {
            label: "一般工商业（地铁）",
            value: 4
          },
          {
            label: "一般工商业（非工业用电）",
            value: 5
          },
          {
            label: "一般工商业（商业）",
            value: 6
          },
          {
            label: "一般工商业（普通工业除外）",
            value: 7
          },
          {
            label: "一般工商业（普通工业专变）",
            value: 8
          },
          {
            label: "一般工商业 （商业、非工业、非专变普通工业）",
            value: 9
          },
          {
            label: "居民用户",
            value: 10
          },
          {
            label: "合表用户",
            value: 11
          }
        ],
        volLevelOptions:[
          {
            label: "0.22kV",
            value: 1
          },
          {
            label: "0.38kV",
            value: 2
          },
          {
            label: "10kV",
            value: 3
          },
          {
            label: "35kV",
            value: 4
          },
          {
            label: "66kV",
            value: 5
          },
          {
            label: "110kV",
            value: 6
          },
          {
            label: "220kV",
            value: 7
          }
        ],
        formData: {
          owner: '',
          locationStr: '',
          electricityType:'',
          volLevel:''
        },
        dlgCopyTitle: "复制并网点",
        copyFormData: {},
        userData: {},
        total: 0,
        dlgTitle: '新增并网点',
        pageList: [10, 20, 30, 50],
        tableData: [],
        roleData: [],
        projectOptions: [{
          label: '信诚一期',
          value: '111'
        }],
        copyRules: {
          gridName: [{
            required: true,
            message: '请输入并网点名称',
            trigger: 'blur'
          }],
          volLevel: [{
            required: true,
            message: '请选择电压等级',
            trigger: 'change'
          }]
        },
        rules: {
          projectId: [{
            required: true,
            message: '请选择项目',
            trigger: 'change'
          }],
          gridName: [{
            required: true,
            message: '请输入并网点名称',
            trigger: 'blur'
          }],
          volLevel: [{
            required: true,
            message: '请选择电压等级',
            trigger: 'change'
          }]
        },
        currentRow: {}, //选中的当前行
        sexOptions: [{
            label: '男',
            value: 1
          },
          {
            label: '女',
            value: 2
          }
        ]
      };
    },
    methods: {
      //设置每行的颜色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return '';
        if (rowIndex === 0) {
          return 'warning-row';
        } else if (rowIndex === 1) {
          return 'success-row';
        }
      },
      bindDevice(row) {
        this.$emit('bindDevice', {
          row: row,
          params: this.form
        })
      },
      //初始数据
      init() {
        //获取项目列表
        this.getAllProjects()
        this.searchProjectGridList()
      },
      getAllProjects() {
        API.getAllProjects().then(res => {
          if (res.data.code == 200) {
            this.projectOptions = res.data.data
          }
        })
      },
      getProjectDetails(id) {
        API.searchProjectDetail({
          projectId: id
        }).then(res => {
          if (res.data.code == 200) {
            let data = res.data.data
            this.formData.owner = data.owner
            this.formData.locationStr = data.locationStr
            this.formData = JSON.parse(JSON.stringify(this.formData))
          }
        })
      },
      //获取用户列表数据
      searchProjectGridList() {
        this.tableData = [];
        let params = this.form;
        API.searchProjectGridList(params).then(res => {
          this.tableData = res.data.data.dataList;
          this.total = Number(res.data.data.totalCount);
        });
      },
      //显示角色列表
      showAddDiloag(row, data) {
        if (row === true) {
          this.dlgTitle = '新增并网点'
          this.formData = {}
        } else if (row === false) {
          this.dlgTitle = '详情'
          this.formData = data
        } else {
          this.dlgTitle = '编辑并网点'
          this.formData = row
        }
        this.$refs.dlgAdd.open();
      },
      //添加并网点
      addProjectGrid(f) {
        let params = {};
        params.projectId = this.formData.projectId;
        params.gridName = this.formData.gridName;
        params.volLevel = this.formData.volLevel;
        if (this.formData.id) {
          if (f == true) {
            API.addProjectGrid(params).then(res => {
              if (res.data.code == 200) {
                this.$message.success('操作成功');
                this.searchProjectGridList();
              }
            });
          } else {
            params = {
              id: this.formData.id,
              gridName: this.formData.gridName,
              volLevel:this.formData.volLevel
            }
            API.updateProjectGrid(params).then(res => {
              if (res.data.code == 200) {
                this.$message.success('操作成功');
                this.searchProjectGridList();
              }
            });
          }
        } else {
          API.addProjectGrid(params).then(res => {
            if (res.data.code == 200) {
              this.$message.success('操作成功');
              this.searchProjectGridList();
            }
          });
        }

      },
      copy(row) {
        this.$refs.dlgCopy.open()
        this.formData = row
      },
      //复制并网点
      onCopy(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.addProjectGrid(true)
            this.onCopyCancel()
          } else {
            return false;
          }
        });
      },
      //取消复制
      onCopyCancel() {
        this.$refs.dlgCopy.close();
      },
      //保存
      onSave(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.addProjectGrid()
            this.onCancel()
          } else {
            return false;
          }
        });
      },
      //取消保存
      onCancel() {
        this.$refs.dlgAdd.close();
      },
      //设置页数
      handleSizeChange(val) {
        this.form.pageSize = val;
        this.searchProjectGridList();
      },
      //设置当前页
      handleCurrentChange(val) {
        this.form.pageNum = val;
        this.searchProjectGridList();
      }
    },
    created() {
      //重置条件
      if (this.params) {
        this.form = this.params
      }
      this.init();
    }
  };
</script>

<style lang="scss">
  @import './static/css/boss.scss';

  .parallel-list {
    .el-table .warning-row {
      background: oldlace;
    }

    .el-table .success-row {
      background: #f0f9eb;
    }

    .parallel-dlg {
      .el-select {
        width: 100% !important;
      }

      .el-dialog__wrapper {
        .el-dialog {
          .el-dialog__footer {
            padding: 0px !important;
          }
        }
      }
    }
  }

  .btn-tools {
    text-align: right;
    margin-top: 35px;

    .btn {
      width: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/boss/parallelBranch/list.vue